// removed by extract-text-webpack-plugin
module.exports = {"card":"src-components-modules-Card-style----general-module---card---2QqGu bg-white height-100 overflow-hidden position-relative transitionDuration-m","withMargin":"src-components-modules-Card-style----general-module---withMargin---1zuZM","border":"src-components-modules-Card-style----general-module---border---1y55b borderStyle-solid borderColor-snow--xd borderWidth-1","shadow":"src-components-modules-Card-style----general-module---shadow---2B2nk","borderRadius":"src-components-modules-Card-style----general-module---borderRadius---6UGLZ borderRadius-m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Card/style/general.module.css
// module id = 1435
// module chunks = 168707334958949